/**
 * @file 横スクロールする table の sticky で固定する列をセットする
 */
'use strict'

/**
 * @classname TableSetStickyColumns
 * @classdesc 横スクロールする table の sticky で固定する列をセットする
 */
export default class TableSetStickyColumns {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.table-set-sticky-columns')
	 */
	constructor($e) {
		console.log(`TableSetStickyColumns.constructor`)
		this._$e = $e
		if($e.hasClass('table-search-member-report')){
			this.searchMemberInitialize();
		}else{
			this._stickyColumnsCount = this._$e.data('sticky-columns-count')
			this._targetTheadColumnIndex = this._$e.data('target-thead-row-index') || 1
			this.initialize()
		}
	}


	/**
	 * 初期化
	 *
	 * @memberof TableSetStickyColumns
	 */
	initialize() {
		console.log(`TableSetStickyColumns.initialize`)
		let left = 0
		const theadColumns = this._$e.find('.thead .tr').eq(this._targetTheadColumnIndex - 1).find('.th')
		for (let i = 0; i < this._stickyColumnsCount; i++) {
			$(theadColumns[i]).css({
				position: 'sticky',
				left: left,
			})
			left += $(theadColumns[i]).outerWidth()
			$(theadColumns[i]).append(this.createBorderElement({left: '-1px'}))
			$(theadColumns[i]).append(this.createBorderElement({right: '-1px'}))
		}
		let skipRowCount = 0
		this._$e.find('.tbody .tr').each((idx, row) => {
			left = 0
			const tbodyColumns = $(row).find('.td')
			const firstTdPosition = $(tbodyColumns[0]).position()
			console.log(`log ::: skipRowCount: ${skipRowCount} / firstTdPosition.left: ${firstTdPosition.left}`)
			if (skipRowCount != 0 && firstTdPosition.left > 1) {
				skipRowCount--
				return true
			}
			console.log(`log ::: $(tbodyColumns[0]).attr('rowspan'): ${$(tbodyColumns[0]).attr('rowspan')}`)
			skipRowCount = $(tbodyColumns[0]).attr('rowspan') ? $(tbodyColumns[0]).attr('rowspan') - 1 : 0
			for (let i = 0; i < this._stickyColumnsCount; i++) {
				$(tbodyColumns[i]).css({
					position: 'sticky',
					left: left,
					backgroundColor: idx % 2 == 0 ? '#F2F2F3' : '#FFF',
				})
				left += $(tbodyColumns[i]).outerWidth()
				$(tbodyColumns[i]).append(this.createBorderElement({left: '-1px'}))
				$(tbodyColumns[i]).append(this.createBorderElement({right: '-1px'}))
			}
		})
	}


	/**
	 * ボーダー表示用要素を生成
	 *
	 * @memberof TableSetStickyColumns
	 */
	createBorderElement(additionalStyle) {
		const borderElementBaseStyle = {
			position: 'absolute',
			top: 0,
			width: '1px',
			height: '100%',
			backgroundColor: '#d8dbe0'
		}
		return $('<div></div>', {
			css: {
				...borderElementBaseStyle,
				...additionalStyle,
			}
		})
	}

	/**
	 * ボーダー表示用要素を生成
	 *
	 * @memberof TableSetStickyColumns
	 */
	createBorderBottomElement() {
		const borderElementBaseStyle = {
			position: 'absolute',
			left: 0,
			height: '1px',
			width: '100%',
			backgroundColor: '#d8dbe0',
			bottom: '-1px'
		}
		return $('<div></div>', {
			css: {
				...borderElementBaseStyle,
			}
		})
	}


	/**
	 * ボーダー表示用要素を生成
	 *
	 * @memberof TableSetStickyColumns
	 */
	createBorderTopElement() {
		const borderElementBaseStyle = {
			position: 'absolute',
			left: 0,
			height: '1px',
			width: '100%',
			backgroundColor: '#d8dbe0',
			top: '-1px'
		}
		return $('<div></div>', {
			css: {
				...borderElementBaseStyle,
			}
		})
	}


	/**
	 * 初期化
	 *
	 * @memberof TableSetStickyColumns
	 */
	searchMemberInitialize() {
		console.log(`TableSetStickyColumns.searchMemberInitialize`)
		const $row0column0 = this._$e.find('.thead .tr').eq(0).find('.th').eq(0);
		const $row0column1 = this._$e.find('.thead .tr').eq(0).find('.th').eq(1);
		const $row0column2 = this._$e.find('.thead .tr').eq(0).find('.th').eq(2);
		const $row1column0 = this._$e.find('.thead .tr').eq(1).find('.th').eq(0);
		const $row1column1 = this._$e.find('.thead .tr').eq(1).find('.th').eq(1);
		const $row1column2 = this._$e.find('.thead .tr').eq(1).find('.th').eq(2);
		const $row1column3 = this._$e.find('.thead .tr').eq(1).find('.th').eq(3);

		let left0 = 0;
		let left1 = left0 + $row0column0.outerWidth();
		let left2 = left1 + $row1column0.outerWidth();
		let left3 = left2 + $row1column1.outerWidth();
		let left4 = left3 + $row1column2.outerWidth();

		$row0column0.css({position: 'sticky', left: left0}).append(this.createBorderElement({left: '-1px'}))
		$row0column0.css({position: 'sticky', left: left0}).append(this.createBorderElement({right: '-1px'}))
		$row0column1.css({position: 'sticky', left: left1}).append(this.createBorderElement({left: '-1px'}))
		$row0column1.css({position: 'sticky', left: left1}).append(this.createBorderElement({right: '-1px'}))
		$row1column0.css({position: 'sticky', left: left1}).append(this.createBorderElement({left: '-1px'}))
		$row1column0.css({position: 'sticky', left: left1}).append(this.createBorderElement({right: '-1px'}))
		$row1column1.css({position: 'sticky', left: left2}).append(this.createBorderElement({left: '-1px'}))
		$row1column1.css({position: 'sticky', left: left2}).append(this.createBorderElement({right: '-1px'}))
		$row0column2.css({position: 'sticky', left: left3}).append(this.createBorderElement({left: '-1px'}))
		$row0column2.css({position: 'sticky', left: left3}).append(this.createBorderElement({right: '-1px'}))
		$row1column2.css({position: 'sticky', left: left3}).append(this.createBorderElement({left: '-1px'}))
		$row1column2.css({position: 'sticky', left: left3}).append(this.createBorderElement({right: '-1px'}))
		$row1column3.css({position: 'sticky', left: left4}).append(this.createBorderElement({left: '-1px'}))
		$row1column3.css({position: 'sticky', left: left4}).append(this.createBorderElement({right: '-1px'}))
		$row0column1.append(this.createBorderBottomElement());
		$row0column2.append(this.createBorderBottomElement());
		$row1column0.append(this.createBorderTopElement());
		$row1column1.append(this.createBorderTopElement());
		$row1column2.append(this.createBorderTopElement());
		$row1column3.append(this.createBorderTopElement());
		let skipRowCount = 0
		this._$e.find('.tbody .tr').each((idx, row) => {
			let left = 0
			const tbodyColumns = $(row).find('.td')
			const firstTdPosition = $(tbodyColumns[0]).position()
			console.log(`log ::: skipRowCount: ${skipRowCount} / firstTdPosition.left: ${firstTdPosition.left}`)
			if (skipRowCount != 0 && firstTdPosition.left > 1) {
				skipRowCount--
				return true
			}
			console.log(`log ::: $(tbodyColumns[0]).attr('rowspan'): ${$(tbodyColumns[0]).attr('rowspan')}`)
			skipRowCount = $(tbodyColumns[0]).attr('rowspan') ? $(tbodyColumns[0]).attr('rowspan') - 1 : 0
			for (let i = 0; i < 5; i++) {
				$(tbodyColumns[i]).css({
					position: 'sticky',
					left: left,
					backgroundColor: idx % 2 == 0 ? '#F2F2F3' : '#FFF',
				})
				left += $(tbodyColumns[i]).outerWidth()
				$(tbodyColumns[i]).append(this.createBorderElement({left: '-1px'}))
				$(tbodyColumns[i]).append(this.createBorderElement({right: '-1px'}))
			}
		})
	}
}
